import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/global-error.tsx")